'use client';

import { PaperClipIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';

interface ChatAttachmentChipProps {
  filename: string;
  /** When omitted the chip is read-only — used inside a message bubble, where removal is meaningless. */
  onRemove?: () => void;
}

export const ChatAttachmentChip = ({ filename, onRemove }: ChatAttachmentChipProps) => {
  const { t } = useTranslation('common');

  return (
    <span className="inline-flex max-w-full items-center gap-1 rounded-lg bg-surface-100 px-2 py-1 text-xs text-ink">
      <PaperClipIcon className="size-3.5 shrink-0" />
      <span className="truncate">{filename}</span>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={t('global.action.remove')}
          className="shrink-0 rounded p-0.5 hover:bg-surface-200"
        >
          <XMarkIcon className="size-3.5" />
        </button>
      )}
    </span>
  );
};
